import React from "react"
import type { CSSProperties } from "react"

type InfoIconProps = {
  style?: CSSProperties
  className?: string
}

export default function InfoIcon({ style, className }: InfoIconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      aria-hidden="true"
    >
      <path
        d="M12.5 0.390625C5.81265 0.390625 0.390625 5.8146 0.390625 12.5C0.390625 19.1893 5.81265 24.6094 12.5 24.6094C19.1874 24.6094 24.6094 19.1893 24.6094 12.5C24.6094 5.8146 19.1874 0.390625 12.5 0.390625ZM12.5 5.76172C13.6326 5.76172 14.5508 6.67988 14.5508 7.8125C14.5508 8.94512 13.6326 9.86328 12.5 9.86328C11.3674 9.86328 10.4492 8.94512 10.4492 7.8125C10.4492 6.67988 11.3674 5.76172 12.5 5.76172ZM15.2344 18.1641C15.2344 18.4876 14.972 18.75 14.6484 18.75H10.3516C10.028 18.75 9.76562 18.4876 9.76562 18.1641V16.9922C9.76562 16.6686 10.028 16.4062 10.3516 16.4062H10.9375V13.2812H10.3516C10.028 13.2812 9.76562 13.0189 9.76562 12.6953V11.5234C9.76562 11.1999 10.028 10.9375 10.3516 10.9375H13.4766C13.8001 10.9375 14.0625 11.1999 14.0625 11.5234V16.4062H14.6484C14.972 16.4062 15.2344 16.6686 15.2344 16.9922V18.1641Z"
        fill="var(--blue-500)"
      />
    </svg>
  )
}
